const CLARITY_CONSENT_STORAGE_KEY = 'cookiesAccepted'
const CLARITY_PROJECT_ID = import.meta.env.VITE_CLARITY_PROJECT_ID
const CLARITY_SCRIPT_ID = 'microsoft-clarity-script'
const CLARITY_COUNTRY = String(import.meta.env.VITE_BASE_PATH || '')
  .replace(/^\/+|\/+$/g, '')

const CLARITY_GRANTED_CONSENT = {
  ad_Storage: 'denied',
  analytics_Storage: 'granted',
}

const CLARITY_DENIED_CONSENT = {
  ad_Storage: 'denied',
  analytics_Storage: 'denied',
}

function isClarityEnabled() {
  return typeof window !== 'undefined'
    && typeof document !== 'undefined'
    && __CLARITY_ENABLED__
    && Boolean(CLARITY_PROJECT_ID)
}

function getClarityQueue() {
  if (typeof window.clarity === 'function') return window.clarity

  const clarity = function () {
    clarity.q = clarity.q || []
    clarity.q.push(arguments)
  }

  window.clarity = clarity
  return clarity
}

function injectClarityScript() {
  if (document.getElementById(CLARITY_SCRIPT_ID)) return

  const script = document.createElement('script')
  script.id = CLARITY_SCRIPT_ID
  script.async = true
  script.src = `https://www.clarity.ms/tag/${encodeURIComponent(CLARITY_PROJECT_ID)}`
  script.onerror = () => script.remove()
  document.head.appendChild(script)
}

let isClarityInitialized = false

// consentv2 é enfileirado antes da injeção; chamadas seguintes só atualizam o consentimento
function applyClarityConsent(consent) {
  if (!isClarityEnabled()) return false

  const clarity = getClarityQueue()
  clarity('consentv2', consent)

  if (isClarityInitialized) return true
  isClarityInitialized = true

  clarity('set', 'country', CLARITY_COUNTRY)
  clarity('set', 'environment', 'production')
  injectClarityScript()

  return true
}

export function grantClarityConsent() {
  return applyClarityConsent(CLARITY_GRANTED_CONSENT)
}

export function denyClarityConsent() {
  return applyClarityConsent(CLARITY_DENIED_CONSENT)
}

export function initializeClarityFromConsent() {
  let isAccepted = false

  try {
    isAccepted = sessionStorage.getItem(CLARITY_CONSENT_STORAGE_KEY) === 'true'
  } catch (error) {
    isAccepted = false
  }

  return isAccepted ? grantClarityConsent() : denyClarityConsent()
}

export function tagClarityRoute(route) {
  if (!isClarityEnabled() || typeof window.clarity !== 'function' || !route?.name) return false

  window.clarity('set', 'route', String(route.name))
  return true
}
